import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

const axiosConfig = {
    validateStatus: function (status: number) {
        return status < 500;
    },
};

const axiosConfigFileDownload : AxiosRequestConfig = {
    validateStatus: function (status: number) {
        return status < 500;
    },
    responseType: "blob"
};
export class BaseRestService {
    axios: AxiosInstance;
    rootResource: string;

    constructor(axios: AxiosInstance, resource: string) {
        this.axios = axios;
        this.rootResource = resource;
    }

    async get(path: string): Promise<AxiosResponse<any, any>> {
        const response = await this.axios.get(this.rootResource + path, axiosConfig);
        return response;
    }

    async getFile(path: string): Promise<AxiosResponse<any, any>> {
        const response = await this.axios.get(this.rootResource + path, axiosConfigFileDownload);
        return response;
    }

    async post(path: string, data: any): Promise<AxiosResponse<any, any>> {
        const response = await this.axios.post(this.rootResource + path, data, axiosConfig);
        return response;
    }

    async put(path: string, data: any): Promise<AxiosResponse<any, any>> {
        const response = await this.axios.put(this.rootResource + path, data, axiosConfig);
        return response;
    }

    async delete(path: string): Promise<AxiosResponse<any, any>> {
        const response = await this.axios.delete(this.rootResource + path, axiosConfig);
        return response;
    }

    async postMultipart(path: string, data: any, files: File[]): Promise<AxiosResponse<any, any>> {
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            formData.append("files", file, file.name);
        }

        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value as string);
        }

        const response = await this.axios.post(this.rootResource + path, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            ...axiosConfig,
        });

        return response;
    }
}
